import { unpack, flatten } from '@/legacy/lib//util';
import Model from '@/legacy/lib//Model';

export default class Result extends Model
{
  constructor (props)
  {
    super ()

    Object.assign (
      this,
      unpack (props || {})
    );
  }

  max (key)
  {
    return Math.max (
      ... this
        .getPlayers ()
        .map (p => p [key])
    );
  }

  getPlayers ()
  {
    return flatten (
      this
        .teams
        .map (t => t.players)
    );
  }

  getPlayer (name)
  {
    return this
      .getPlayers ()
      .find (p => p.name === name);
  }
}